import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const {FiInstagram,FiCamera}=FiIcons;

const PhotoCorner=()=> {
return (
<section className="py-20 px-6 bg-cream">
<div className="max-w-6xl mx-auto">
<div className="grid md:grid-cols-2 gap-12 items-center">
<motion.div initial={{opacity: 0,x: 30}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="relative order-2 md:order-1" >
<img src="https://cdn1.sharemyimage.com/smi/2025/10/24/Banh-Mi-La-Vie-Saigon-art.png" alt="Beautiful La Vie Saigon art display" className="rounded-lg shadow-2xl w-full h-96 object-cover" />
<div className="absolute inset-0 bg-gradient-to-t from-warm-brown/20 to-transparent rounded-lg"></div>
{/* Floating Instagram Icon */}
<motion.div initial={{opacity: 0,scale: 0}} whileInView={{opacity: 1,scale: 1}} transition={{duration: 0.6,delay: 0.5}} viewport={{once: true}} className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-full shadow-lg" >
<SafeIcon icon={FiCamera} className="text-warm-brown text-2xl" />
</motion.div>
</motion.div>
<motion.div initial={{opacity: 0,x: -30}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="space-y-6 order-1 md:order-2" >
<h2 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-6"> La Vie Moments </h2>
<h3 className="text-2xl font-playfair text-warm-brown/90 mb-4"> Capture Your Moment at La Vie Saigon </h3>
<p className="text-lg text-warm-brown/80 leading-relaxed"> Every corner of La Vie Saigon is designed to tell a story — yours. From our signature logo wall bathed in warm lighting to cozy nooks adorned with lush plants,our space invites you to create memories. </p>
<p className="text-lg text-warm-brown/80 leading-relaxed"> Enjoy your coffee,savor your pastry,take a photo,and share it with the world. Let your friends know where life tastes its best. </p>
<motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.4}} viewport={{once: true}} className="pt-6" >
<button className="bg-warm-brown text-cream px-8 py-4 rounded-full text-lg font-medium hover:bg-warm-brown/90 transition-colors duration-300 shadow-lg flex items-center gap-3">
 <SafeIcon icon={FiInstagram} className="text-xl" />
 Tag us #LaVieSaigon
</button>
</motion.div>
</motion.div>
</div>
</div>
</section>
);};
export default PhotoCorner;